import { httpsCallable } from "firebase/functions";
import { functions } from "./firebaseApp";
import type { PlannerConfig } from "../types";

async function call<TInput, TResult>(name: string, data: TInput): Promise<TResult> {
  const callable = httpsCallable<TInput, TResult>(functions, name);
  const result = await callable(data);
  return result.data;
}

export const api = {
  submitRequest: (data: { firstName: string; lastName: string; phone: string; reason: string; website: string }) =>
    call<typeof data, { requestId: string }>("submitRequest", data),
  getConfig: () => call<Record<string, never>, PlannerConfig>("getConfig", {}),
  saveConfig: (data: PlannerConfig) => call<PlannerConfig, PlannerConfig>("saveConfig", data),
  createAppointment: (data: {
    requestId?: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
    reason?: string;
    date: string;
    startTime: string;
  }) => call<typeof data, { appointmentId: string }>("createAppointment", data),
  moveAppointment: (data: { appointmentId: string; date: string; startTime: string }) =>
    call<typeof data, { appointmentId: string }>("moveAppointment", data),
  updateAppointment: (data: { appointmentId: string; firstName: string; lastName: string; phone: string; reason: string }) =>
    call<typeof data, { appointmentId: string }>("updateAppointment", data),
  cancelAppointment: (appointmentId: string) =>
    call<{ appointmentId: string }, { appointmentId: string }>("cancelAppointment", { appointmentId }),
  sendSmsBatch: (appointmentIds: string[]) => call<
    { appointmentIds: string[] },
    { results: Array<{ appointmentId: string; success: boolean; error: string | null }>; skipped: Array<{ appointmentId: string; reason: string }> }
  >("sendSmsBatch", { appointmentIds }),
  syncSmsDeliveryReports: () => call<
    Record<string, never>,
    { checked: number; updated: number; withoutReport: number; failed: number }
  >("syncSmsDeliveryReports", {}),
  closePeriod: (confirmation: string) => call<
    { confirmation: string },
    {
      appointments: number;
      requests: number;
      smsLogs: number;
      smsProviderRefs: number;
      smsDlrInbox: number;
      smsDlrEvents: number;
      webhookNonces: number;
      rateLimits: number;
    }
  >("closePeriodAndDeleteData", { confirmation })
};
